import { render, staticRenderFns } from "./generalInstruction.vue?vue&type=template&id=efd28fc4"
import script from "./generalInstruction.vue?vue&type=script&lang=js"
export * from "./generalInstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports